import { z } from 'zod';
import { REPORT_COLUMNS, type ReportColumn } from '@itvisits/shared';
import type { ReportParams } from '../../api/reports';
import { DEFAULT_SEARCH, type VisitSearch } from '../visits/VisitFilters';
import { fromSearchParams, toSearchParams, visitSearchSchema } from '../visits/search';

const columnList = z.preprocess(
  (v) => (typeof v === 'string' ? v.split(',').filter(Boolean) : Array.isArray(v) ? v : undefined),
  z.array(z.enum(REPORT_COLUMNS)).min(1).optional(),
);

/** /reports search: the visits filters plus an optional column list (Q32: picker persists in URL). */
export const reportSearchSchema = visitSearchSchema.extend({
  columns: columnList.catch(undefined),
});
export type ReportSearchParams = z.infer<typeof reportSearchSchema>;

export interface ReportSearch extends VisitSearch {
  columns?: ReportColumn[] | undefined;
}

export const DEFAULT_REPORT_SEARCH: ReportSearch = { ...DEFAULT_SEARCH, wip: false };

export function fromReportParams(p: ReportSearchParams): ReportSearch {
  return { ...fromSearchParams(p), columns: p.columns };
}

export function toReportParams(s: ReportSearch): ReportSearchParams {
  return { ...toSearchParams(s), ...(s.columns?.length ? { columns: s.columns } : {}) };
}

export function toApiParams(s: ReportSearch, pageSize: number): ReportParams {
  return {
    status: s.status,
    technicianId: s.technicianId,
    facilityId: s.facilityId,
    clusterId: s.clusterId,
    from: s.from,
    to: s.to,
    wip: s.wip,
    q: s.q,
    sort: s.sort,
    columns: s.columns,
    page: s.page,
    pageSize,
  };
}
